module.exports = __webpack_public_path__ + "b0ac67b6082c552d8b76e101ff694f42.pdf";